<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive, nextTick, getCurrentInstance } from "vue";
import { getSiteData, goBack } from "@/NavigationHelper";
import { Globals } from "@/Globals";
import baseSyncSchedule from "@/components/baseSyncSchedule.vue";
import { BaseSetup } from "@/DataLoaderStatic";
import { checkBegriff, globalsKennung, globalsBezeichnung } from "@/local";
const emit = defineEmits(["back"]);

let abwZeitraum: Date = AUApi.Current.zeitbereich.von;
let showTimeLineMonth = ref<boolean>(false);
let showWeek = ref<boolean>(false);
let currentView = ref<string>("Month");
let allowDragAndDrop = ref<boolean>(false);
let toggleSight = ref<string>("abwesenheiten");

let showStempelantrag = ref<boolean>(false);
let showDetailantrag = ref<boolean>(false);
let editorComponent = ref<string>("");
let showQuickInfo: boolean = false;
let showMonth: boolean = true;
let setMinDate: boolean = false;
let query: string = "";
let saveQuery = ref<string>("");
let showGroup = ref<boolean>(true);
let queryMitarbeiter = ref<string>("");
let group2: string = "";
let readBewilligt: boolean = false;
let readOnly: boolean = false;
let onlyEdit = ref<boolean>(true);
let saveModell = ref<string>("");
let useCellTemplate = ref<boolean>(false);
let loading = ref<boolean>(false);
let loading1 = ref<boolean>(false);
let disabled = ref<boolean>(false);
let hideMeForRefresh = ref<boolean>(true);
let showRow: number = 0;
let group: any = {};
let loader: any = null;
let showBack = ref<boolean>(false);
let formularUebergabe = ref<ALLFrame>();
const siteData = getSiteData();

const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  emitBack: () => emit("back"),
};
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));
onMounted(async () => {
  hideMeForRefresh.value = true;
  formularUebergabe = globalsKennung(
    Globals.Begriff,
    "PzePersoenlichPlanungenAntraege"
  );
  showRow = 0;
  if (siteData?.showBack) {
    showBack = siteData.showBack;
  }
  if (checkBegriff("Lizenz_korrekturantraege")) {
    showStempelantrag.value = true;
    showRow++;
  }
  if (checkBegriff("Web_SW_Detailantrag")) {
    showDetailantrag.value = true;
    showRow++;
  }
  if (siteData?.toggleUebergabe) {
    toggleSight.value = siteData.toggleUebergabe;
  } else if (localStorage.activeTabAntragMA) {
    if (
      localStorage.activeTabAntragMA !== "undefined" &&
      localStorage.activeTabAntragMA !== "" &&
      localStorage.activeTabAntragMA !== "null"
    ) {
      toggleSight.value =
        window.localStorage.getItem("activeTabAntragMA") ?? "";
    } else {
      if (checkBegriff("Lizenz_korrekturantraege")) {
        toggleSight.value = "Stempelantraege";
      } else if (checkBegriff("Web_SW_Detailantrag")) {
        toggleSight.value = "Detailantraege";
      }
    }
  } else {
    if (checkBegriff("Lizenz_korrekturantraege")) {
      toggleSight.value = "Stempelantraege";
    } else if (checkBegriff("Web_SW_Detailantrag")) {
      toggleSight.value = "Detailantraege";
    }
  }
  await changeView();
});
async function onloaded(loaded?: boolean) {
  if (loaded) {
    setTimeout(() => {
      loading.value = false;
      loading1.value = false;
      disabled.value = false;
    }, 300);
  }
}
function onZeitraum(newZeitraum: any) {
  abwZeitraum = newZeitraum;
}
async function changeView() {
  loading.value = false;
  loading1.value = false;
  disabled.value = true;
  hideMeForRefresh.value = true;
  const instance = getCurrentInstance();
  // akt. Tab merken für refresh!
  const activeTabAntragMA = window.localStorage.setItem(
    "activeTabAntragMA",
    toggleSight.value
  );
  formularUebergabe.value = undefined;
  if (toggleSight.value === "Stempelantraege") {
    loading.value = true;
    query = "Web_offeneAntraege_proMA";
    editorComponent.value = "PzePersoenlichPlanungenTemplatesStempelungen";
    queryMitarbeiter.value = "";
    readBewilligt = true;

    allowDragAndDrop.value = false;
    setMinDate = false;
    saveQuery.value = "";
    useCellTemplate.value = true;
  } else if (toggleSight.value === "Detailantraege") {
    loading1.value = true;
    setMinDate = false;
    query = "Web_Uebersicht_MA_Detailantrag";
    editorComponent.value =
      "PzePersoenlichPlanungenTemplatesDialogDetailantrag";
    queryMitarbeiter.value = "";
    readBewilligt = true;
    allowDragAndDrop.value = false;
    useCellTemplate.value = true;
    saveQuery.value = "";
  }
  hideMeForRefresh.value = false;
}
</script>
<template>
  <v-btn-toggle
    v-if="showRow > 1 || showBack"
    class="dvhToggle my-4 pa-0 d-flex flex-wrap"
    v-model="toggleSight"
    @update:model-value="changeView"
    divided
    tile
    variant="text"
  >
    <v-btn
      :loading="loading"
      variant="text"
      v-if="showStempelantrag"
      value="Stempelantraege"
      :disabled="disabled"
    >
      {{
        globalsBezeichnung(
          Globals.Begriff,
          "LZ_Korrekturantrag_VG",
          "Korrekturantrag"
        )
      }}
      <template v-slot:loader>
        <span class="custom-loader">
          <v-icon light>mdi-cached</v-icon>
        </span>
      </template>
    </v-btn>

    <v-btn
      :loading="loading1"
      variant="text"
      value="Detailantraege"
      v-if="showDetailantrag"
      :disabled="disabled"
    >
      {{
        globalsBezeichnung(
          Globals.Begriff,
          "Lizenz_DetailantragVG_Sicht",
          "Detailantrag"
        )
      }}
      <template v-slot:loader>
        <span class="custom-loader">
          <v-icon light>mdi-cached</v-icon>
        </span>
      </template>
    </v-btn>
    <v-btn v-if="showBack" variant="text" @click="goBack()"
      ><v-icon>mdi-close</v-icon></v-btn
    >
  </v-btn-toggle>

  <baseSyncSchedule
    :key="toggleSight"
    ref="schedule"
    :query="query"
    :editorComponent="editorComponent"
    :currentView="currentView"
    :showQuickInfo="showQuickInfo"
    :showMonth="showMonth"
    :saveQuery="saveQuery"
    :showGroup="showGroup"
    :group="group"
    :queryMitarbeiter="queryMitarbeiter"
    :readBewilligt="true"
    v-if="!hideMeForRefresh"
    @zeitraumChanged="onZeitraum"
    @loaded="onloaded"
    :abwZeitraum="abwZeitraum"
    :formular="formularUebergabe"
    :showTimeLineMonth="showTimeLineMonth"
    :useCellTemplate="useCellTemplate"
    :allowDragAndDrop="allowDragAndDrop"
    :onlyEdit="onlyEdit"
    :showWeek="showWeek"
    :saveModell="saveModell"
    :gotoToday="false"
    :reload="true"
  />
</template>
<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 550px) {
  .v-btn-toggle--dense > .v-btn.v-btn {
    padding: 0 0px;
  }
  .v-btn.v-size--default,
  .v-btn.v-size--large {
    font-size: small;
  }
}
</style>
